<template>
  <div class="w-full h-full" test-id="main">
    <div v-if="isLoading">
      <div
        v-loading="isLoading"
        :element-loading-text="
          isClosing ? 'Redirecting...' : 'loading account opening form...'
        "
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="w-full h-screen"
      ></div>
    </div>
    <div :class="isLoading ? 'hidden' : 'block'" class="relative min-h-screen">
      <div class="pb-24 pt-4">
        <div
          v-if="breakpoints.w > 950"
          class="flex items-start pl-6 w-full m-10"
        >
          <logo-icon />
        </div>
        <div class="flex w-full justify-center">
          <div class="w-10/12 lg:w-3/4" id="wrapper">
            <div id="top"></div>
            <div id="down"></div>
          </div>
        </div>
      </div>
      <div class="flex mt-4 footer pt-4 w-full items-start h-24">
        <div class="flex w-full justify-between items-center">
          <div @click="logout" class="flex ml-12 cursor-pointer">
            <logout-icon class="mr-2" />
            <div class="text-red-2">Log Out</div>
          </div>
          <div class="md:flex mr-12">
            <div @click="showTermsOfService" class="pr-3 cursor-pointer">
              Terms of service
            </div>
            |
            <div @click="showPrivacyPolicy" class="pl-3 cursor-pointer">
              Privacy policy
            </div>
          </div>
        </div>
      </div>
    </div>
    <terms-of-service
      v-if="showTermsOfServiceDialog"
      :showDialog="showTermsOfServiceDialog"
      @closeDialog="closeDialog"
    />
    <privacy-policy
      v-if="showPrivacyPolicyDialog"
      :showPrivacyDialog="showPrivacyPolicyDialog"
      @closeDialog="closeDialog"
    />
    <torus-mara-terms-of-service
      v-if="showTorusMaraTermsOfServiceDialog"
      :showDialog="showTorusMaraTermsOfServiceDialog"
      @closeDialog="closeDialog"
    />
    <torus-mara-privacy-policy
      v-if="showTorusMaraPrivacyPolicyDialog"
      :showDialog="showTorusMaraPrivacyPolicyDialog"
      @closeDialog="closeDialog"
    />
  </div>
</template>
<script>
import { USER_TOKEN } from '@/utils/constants'
import breakpoints from '@/utils/breakpoints.js'
import refreshToken from '@/mixins/refreshToken.js'
import logout from '@/mixins/logout.js'
import tenant from '@/mixins/tenant.js'
export default {
  mixins: [refreshToken, logout, tenant],
  data () {
    return {
      isLoading: false,
      breakpoints,
      accountId: null,
      isClosing: false,
      showPrivacyDialog: false,
      showTorusMaraTermsOfServiceDialog: false,
      showTermsOfServiceDialog: false,
      showTorusMaraPrivacyPolicyDialog: false,
      showPrivacyPolicyDialog: false
    }
  },
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue'),
    LogoutIcon: () => import('@/assets/icons/LogoutIcon.vue'),
    TermsOfService: () => import('@/components/base/TermsOfService.vue'),
    PrivacyPolicy: () => import('@/components/base/PrivacyPolicy.vue'),
    TorusMaraTermsOfService: () =>
      import('@/components/base/TorusMaraTermsOfService.vue'),
    TorusMaraPrivacyPolicy: () =>
      import('@/components/base/TorusMaraPrivacyPolicy.vue')
  },
  methods: {
    ptMethod () {
      const vm = this
      const token = this.ptWidgetToken
      // this.isLoading = false
      window.primeTrustReady = function (pt) {
        // or launchCreditCard, launchCreateCompany, launchCreateNaturalPerson
        pt.launchCreateAccount({
          target: document.getElementById('down'),
          resourceTokenHash: token,
          events: {
            loaded: function () {
              vm.isLoading = false
            },
            resourceCreated: function (accountId) {
              localStorage.setItem('accountId', accountId)
              vm.accountId = accountId
              vm.completeWidget()
            }
          }
        })
      }
    },
    logout () {
      localStorage.removeItem(USER_TOKEN)
      this.$router.go()
      localStorage.clear('vuex')
    },
    completeWidget () {
      const vm = this
      this.$store
        .dispatch('auth/completePtAccount', { accountID: this.accountId })
        .then(() => {
          this.isClosing = true
          this.isLoading = true
          this.$store.dispatch('auth/setKycToTrue')
          setTimeout(() => {
            this.$router.push('dashboard')
          }, 2000)
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          if (error.response.data.code === 401) {
            setTimeout(() => {
              this.completeWidget()
            }, 2000)
          } else {
            vm.$message({
              showClose: true,
              message: this.httpErrorMessage,
              type: 'error'
            })
            this.isClosing = true
            this.isLoading = true
            setTimeout(() => {
              this.$store.dispatch(
                'common/setError',
                error.response ? err.id : ''
              )
              this.$router.push('system-error')
            }, 2000)
          }
        })
    },
    closeDialog () {
      this.showTermsOfServiceDialog = false
      this.showPrivacyPolicyDialog = false
      this.showTorusMaraTermsOfServiceDialog = false
      this.showTorusMaraPrivacyPolicyDialog = false
    },
    closePrivacyDialog () {
      this.showPrivacyDialog = false
    },
    async getAccountActivation () {
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('auth/businessConfiguration')
        .then(() => {
          if (!this.ptWidgetToken) {
            vm.$message({
              showClose: true,
              message: "Couldn't redirect to Primetrust",
              type: 'error'
            })
            this.$store.dispatch('common/setError', 'Business not yet active')
            this.$router.push('system-error')
          }
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
          this.isLoading = false
          if (error.response.data && error.response.data.code !== 401) {
            this.$store.dispatch(
              'common/setError',
              error.response ? err.id : ''
            )
            this.$router.push('system-error')
          }
        })
    },
    showTermsOfService () {
      if (this.tenantIsTorus) {
        this.showTorusMaraTermsOfServiceDialog = true
      } else {
        this.showTermsOfServiceDialog = true
      }
    },
    showPrivacyPolicy () {
      if (this.tenantIsTorus) {
        this.showTorusMaraPrivacyPolicyDialog = true
      } else {
        this.showPrivacyPolicyDialog = true
      }
    }
  },
  async mounted () {
    this.refreshTokenTimeout()
    await this.getAccountActivation()
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', process.env.VUE_APP_PT_WIDGET_URL)
    document.head.appendChild(recaptchaScript)
    this.ptMethod()
  },
  computed: {
    ptWidgetToken () {
      const token = this.$store.state.auth.ptWidgetToken
      return token
    }
  }
}
</script>

<style>
.el-loading-spinner .el-loading-text {
  color: var(--color-primary) !important;
}
.el-loading-spinner i {
  color: var(--color-primary) !important;
}
#wrapper {
  margin: 0;
  box-shadow: 0px 12px 26px rgba(16, 30, 115, 0.06);
  border-radius: 15px;
  border: 0.5px solid #818799;
  padding: 10px;
}
#top {
  width: auto;
  padding: 10px;
}
#down {
  width: auto;
  padding: 10px;
  height: 80%;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* height: 20px */
}
</style>
